
export function initNewsletter() {
    const formId = 'newsletter-frm'
    const tokenId = 'newsletter-token'
    const form = document.getElementById(formId)
    const recaptchaEl = document.getElementById('js-recaptcha')
    const siteKey = recaptchaEl ? JSON.parse(recaptchaEl.innerText)?.siteKey : null
    if (form) {
        if (siteKey) {
            const submitHandler = (event) => {
                event.preventDefault();
                let id = 'js-recaptcha-v3'
                let script = document.getElementById(id)
                if (!script) {
                    try {
                        script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.id = id;
                        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
                        document.head.appendChild(script);
                    } catch (e) { }
                }
                script?.addEventListener('load', () => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(siteKey, {action: 'submit'})
                            .then(token => {
                                const tokenEl = document.getElementById(tokenId);
                                tokenEl.value = token;
                                form.removeEventListener('submit', submitHandler, false)
                                form.submit();
                                try {
                                    diffAnalytics?.submitPopupEmail(document.getElementById('newsletter-frm-input').value, function (err, value) {console.log(value)});
                                } catch (e) { }
                            
                                form.addEventListener('submit', submitHandler, false);
                            })
                            .catch(e => console.error(e))
                    })
                });
            }
            form.addEventListener('submit', submitHandler, false);
        } else {
            const submitHandler = (event) => {
                try {
                    diffAnalytics?.submitPopupEmail(document.getElementById('newsletter-frm-input').value, function (err, value) {console.log(value)});
                } catch (e) {}
            }
            form.addEventListener('submit', submitHandler, false);
        }
    }
}